var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonetizationSkillsIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#F7F3E3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.97 12.9601H11.89L11.17 12.2401V8.83009C11.17 7.73009 12.06 6.84009 13.16 6.84009H18.7C19.8 6.84009 20.69 7.73009 20.69 8.83009V12.2401L19.97 12.9601ZM12.61 11.5101H19.25V8.83009C19.25 8.53009 19 8.28009 18.7 8.28009H13.16C12.86 8.28009 12.61 8.52009 12.61 8.83009V11.5101Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.98 22.83H7.07999L6.35999 22.1V12.24L7.07999 11.51H24.77L25.49 12.24V15.22H24.04V12.96H7.80999V21.38H15.98V22.83Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M23.21 27.06H22.49L18.48 24.74L18.12 24.11V19.48L18.48 18.85L22.49 16.53H23.21L27.22 18.85L27.58 19.48V24.11L27.22 24.74L23.21 27.06ZM19.56 23.7L22.85 25.6L26.14 23.7V19.9L22.85 18L19.56 19.9V23.7Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M23.57 19.5802V24.0302L22.85 24.4502L22.12 24.0302V19.5802L22.85 19.1602L23.57 19.5802Z",
    fill: "#09363F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonetizationSkillsIcon3);
export default __webpack_public_path__ + "static/media/monetizationSkills_icon3.d2de3a6eaddfdde006fa5b9c4eab69a1.svg";
export { ForwardRef as ReactComponent };